<div class="col-sm-12 no-padding">

  <h3 class="text-light-blue">
    <b>Exportar documentos</b>
  </h3>
  <hr>

  <div class="col-sm-12 no-padding">
    <p>Selecione o período dos pagamentos:</p>

    <div class="form-group col-sm-3">
      <label>De</label>
      <input type="date" class="form-control" [(ngModel)]="periodoInicial" (change)="relacaoPagamento = []">
    </div>
    <div class="form-group col-sm-3">
      <label>Até</label>
      <input type="date" class="form-control" [(ngModel)]="periodoFinal" (change)="relacaoPagamento = []">
    </div>
    <div class="form-group col-sm-6" style="margin-top: 26px;">
      <button class="btn btn-primary" (click)="geraRelacaoPagamento()">Filtrar</button>
    </div>
  </div>

  <div *ngIf="mostraRelacao" class="col-sm-12 no-padding">

    <hr>

    <div *ngIf="!loading">
      <div class="spinner"></div>
      <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
      </p>
    </div>

    <div *ngIf="loading">

      <div class="col-sm-12 no-padding" *ngIf="relacaoPagamento.length == 0">
        <h4 class="text-muted">Nenhum registro encontrado.</h4>
      </div>

      <div class="col-xs-12 no-padding" *ngIf="relacaoPagamento.length > 0">
        <h4>Documentos encontrados

          <button class="btn btn-sm btn-danger pull-right" (click)="generateMerge()"  *ngIf="!viewDownload"><i
              class="fa fa-fw fa-file-pdf-o"></i> Gerar merge dos documentos</button>

          <button class="btn btn-sm btn-defaulty pull-right" (click)="viewDownload = false" *ngIf="viewDownload" style="margin-right: 10px;">
            <i class="fas fa-reply"></i> Voltar lista de documentos</button>

        </h4>
        <br>


        <table class="table table-striped" *ngIf="!viewDownload">
          <tbody>
            <tr>
              <th>Natureza da despesa</th>
              <th>Nome do favorecido</th>
              <th>Nome arquivo</th>
            </tr>
            <tr *ngFor="let item of relacaoPagamento">
              <td>{{ item.tipoDespesaReceita.descricao }}</td>
              <ng-container *ngIf="item.despesaId">
                <td>{{ item.despesaId.nomeFavorecido }}</td>
                <td>
                  {{ item.despesaId.nfAnexoVencedor }}<br>
                  {{ item.despesaId.comprovanteExtratoBancario }}<br>
                  {{ item.despesaId.comprovanteOrdemBancaria }}
                </td>
              </ng-container>
              <ng-container *ngIf="item.pagamentoPessoalId">
                <td>{{ item.pagamentoPessoalId.pessoalProjeto.nome }}</td>
                <td>
                  {{ item.pagamentoPessoalId.comprovanteTransferencia }}<br>
                  {{ item.pagamentoPessoalId.comprovanteRecibo }}
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>




        <div class="col-sm-12 text-center" *ngIf="viewDownload">
          <div class="embed-container">
            <div class="myIframe">
              <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
          </div>
        </div>



      </div>

    </div>
  </div>


</div>